import { useCallback } from 'react';

import { requestBuilder } from '../../../http/RequestBuilder';

interface CreatePartnerMemberBody {
    partnerEmail: string;
    partnerFirstName: string;
    partnerLastName: string;
}

interface CreatePartnerMemberURLParams {
    userId: string;
}

interface CreatePartnerMemberParams
    extends CreatePartnerMemberBody, CreatePartnerMemberURLParams {
    onSuccess: (userId: string) => void;
    onError: (error: Error) => void;
}

const useMutatePartnerMember = requestBuilder.mutation<
    unknown,
    CreatePartnerMemberBody,
    CreatePartnerMemberURLParams
>({
    endpoint: ({ userId }) => {
        return `/api/user/${userId}/addPartnerMember`;
    },
    method: 'POST',
});

export const useCreatePartnerMember = () => {
    const { mutate, isPending } = useMutatePartnerMember();

    const createPartnerMember = useCallback(
        ({
            userId,
            partnerEmail,
            partnerFirstName,
            partnerLastName,
            onSuccess,
            onError,
        }: CreatePartnerMemberParams) => {
            mutate(
                {
                    urlParams: {
                        userId,
                    },
                    body: {
                        partnerEmail,
                        partnerFirstName,
                        partnerLastName,
                    },
                },
                {
                    onSuccess: () => {
                        onSuccess(userId);
                    },
                    onError,
                },
            );
        },
        [mutate],
    );

    return {
        createPartnerMember,
        isCreatingPartnerMember: isPending,
    };
};
